import React, {Component} from 'react';
import {Buffer} from "buffer";
import MainLayout from "../../components/layouts/MainLayout";
import {withRouter} from "../../hoc/withRouter";
import {Table, message, Col, Button} from 'antd';
import {orderPolicyService} from "../../services/otodisApi/OrderPolicyService";
import {PlusSquareOutlined} from "@ant-design/icons";
import {OrderPolicyStates} from "./types/OrderPolicyTypes";
import withAuth from "../../hoc/withAuth";
import currencyFormat from "../../helper/currencyFormat";
import Cookies from "universal-cookie";

export interface OrderPolicyProps {
}

class OrderPolicy extends Component<OrderPolicyProps & any, OrderPolicyStates> {
    private readonly initState!: OrderPolicyStates;
    private user = JSON.parse(Buffer.from(new Cookies().get("_u"), "base64").toString());
    private uDealer = JSON.parse(Buffer.from(new Cookies().get('_d'), "base64").toString());

    constructor(props: OrderPolicyProps & any | any) {
        super(props);
        const finalDealerCode = props.match.params.dealerCode.replace(/-/g, '#');
        const picked = this.uDealer.find((o: { DealerCode: any; }) => o.DealerCode === finalDealerCode);
        const companyCode = picked?.DealerCompany ?? "AMARTA";

        this.initState = {
            processing: false,
            processingFetchTableData: true,
            dealerCode: props.match.params.dealerCode.replace(/-/g, '#'),
            dataConfig: [],
            pageSize: 500,
            modalAddWarehouse: false,
            addProcessing: false,
            companyCode: companyCode
        }
        this.state = {...this.initState}
    }

    onDealerChange = async (data: any) => {
        await this.promisedSetState({
            processingFetchTableData: true,
            dealerCode: data.value,
        });

        await this.fetchPolicy();
    }

    fetchPolicy = async () => {
        orderPolicyService.getData({companyCode: this.state.companyCode}).then((dataFetchPolicy) => {
            this.setState({
                dealerCode: this.state.dealerCode,
                dataConfig: dataFetchPolicy.data.data,
                processingFetchTableData: false,
            });
        }).catch(async (e) => {
            await this.promisedSetState({
                dataConfig: [],
                processingFetchTableData: false,
            });
            message.error('Data Tidak Ditemukan');
        })
    }

    onChangeTable = (pagination: any, filters: any, sorter: any) => {
        if (pagination?.pageSize) {
            this.setState({
                pageSize: pagination?.pageSize,
            });
        }
    }

    async componentDidMount() {
        await this.fetchPolicy();
    }

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    render() {
        return (
            <React.Fragment>
                <MainLayout noPadNoMar={true} onChangeDealer={this.onDealerChange} breadcrumbPath={`Setting`} breadcrumbMenu={`Kebijakan Order`} defaultSelectedKeys={['m-setting-order-policy']} defaultOpenKeys={['sm-setting']}>
                    <div style={{float: "right", fontSize: "85%", color: "grey"}}>Organization: {this.state.companyCode}</div>
                    <Col span={24} className={`pad-10`}>
                        <a href={`/${this.state.dealerCode.replace(/#/g, '-')}/add-order-policy`}>
                            <Button type={'primary'} icon={<PlusSquareOutlined/>}>Tambah / Update Data</Button>
                        </a>
                    </Col>

                    <Table
                        rowKey={'vehicle_model'}
                        size={'small'}
                        scroll={{x: 'calc(500px + 50%)'}}
                        loading={this.state.processingFetchTableData}
                        columns={[{
                            title: 'Vehicle Model',
                            dataIndex: 'vehicle_model',
                            render: ((value: string, row: []) => {
                                return <span className={`font-90`}>{value}</span>
                            })
                        }, {
                            title: 'Cash',
                            dataIndex: 'cash_type',
                            render: (value: string) => {
                                return <span className={`font-90`}>{value}</span>
                            }
                        }, {
                            title: 'Cash Book Fee',
                            dataIndex: 'cash_book_fee',
                            render: (value: string) => {
                                return <span className={`font-90`}>{currencyFormat(Number(value))}</span>
                            }
                        }, {
                            title: 'Credit',
                            dataIndex: 'credit_type',
                            render: (value: string) => {
                                return <span className={`font-90`}>{value}</span>
                            }
                        }, {
                            title: 'Credit Book Fee',
                            dataIndex: 'credit_book_fee',
                            render: (value: string) => {
                                return <span className={`font-90`}>{currencyFormat(Number(value))}</span>
                            }
                        }, {
                            title: 'Inden Kode',
                            dataIndex: 'indent_code',
                            render: (value: string) => {
                                return <span className={`font-90`}>{(value) ? "true" : "false"}</span>
                            }
                        }]}
                        dataSource={this.state.dataConfig}
                        pagination={{pageSize: this.state.pageSize}}
                        onChange={this.onChangeTable}
                    />
                </MainLayout>
            </React.Fragment>
        );
    }
}

export default (withAuth(withRouter(OrderPolicy), 28));
